import { useBlogArticleCms } from '@/providers/BlogArticleCmsProvider'

import { BuilderContentSection } from './Sections/BuilderContentSection'
import FooterSection from './Sections/FooterSection/FooterSection'
import HeroSection from './Sections/HeroSection/HeroSection'

export const ModernArticleLayout = () => {
  const { content, data, adsTop, adsMiddle, isPreview, relatedArticles } = useBlogArticleCms()
  const { title, subtitle, image } = data.article
  const category = data.category?.value?.data.name
  const product = data.product
  const customPublication = data?.customPublication
  const heroSectionProps = { title, subtitle, adsTop, image, category, customPublication }

  return (
    <>
      <HeroSection {...heroSectionProps} />

      <BuilderContentSection
        data={data}
        content={content}
        adsMiddle={adsMiddle}
        isPreview={isPreview}
      />

      <FooterSection relatedArticles={relatedArticles} product={product} />
    </>
  )
}
